import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  CATALOG_SOURCE_FILTER_OPTIONS,
  catalogSourceFilterDescription,
  type CatalogSourceFilter,
} from "@/lib/catalog-source-filter";

type Props = {
  value: CatalogSourceFilter;
  onChange: (value: CatalogSourceFilter) => void;
};

export default function CatalogSourceFilterSelect({ value, onChange }: Props) {
  return (
    <div className="space-y-1 max-w-xs">
      <p className="text-sm font-medium text-gray-700">Added by</p>
      <Select value={value} onValueChange={(v) => onChange(v as CatalogSourceFilter)}>
        <SelectTrigger className="border-gray-300 bg-white text-gray-900">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {CATALOG_SOURCE_FILTER_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-gray-500">{catalogSourceFilterDescription(value)}</p>
    </div>
  );
}
